/* eslint-disable no-unused-vars */
import { Space, Table, Tooltip } from "antd";
import moment from "moment";
import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { AiOutlineEye } from "react-icons/ai";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import CustomDatePicker from "../../../../components/datePickers/CustomDatePicker";
import ConfirmTransactions from "../../../../components/modals/ConfirmTransactions";
import { deliveryMethod } from "../../../../utils/helpers/objectHelpers";
import { fetchTransactionHistory } from "../../../../utils/services/transfer.service";

function Body({ domainBrand, countries, currencies, paycenters }) {
  const history = useHistory();
  const { Column } = Table;
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const menuPortalTarget = document.getElementById("root");

  const [country, setCountry] = useState({});
  const [currency, setCurrency] = useState({});
  const [delivery, seDeliveryMethod] = useState({});
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [maxAmount, setMaxAMount] = useState("");
  const [minAmount, setMinAmount] = useState("");
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [show, setShow] = useState(false);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRow([...selectedRows]);
    },
  };

  const dispatchTransactionHistory = async (payload) => {
    setLoading(true);
    try {
      const response = await fetchTransactionHistory(payload);
      if (response.data.status === "SUCCESS") {
        setHistoryData(response?.data?.data?.transactionHistory);
        setLoading(false);
        toast.success(`transaction history fetched successfully`);
        setCountry({});
        setTo("");
        setFrom("");
        setMaxAMount("");
        setMinAmount("");
        seDeliveryMethod({});
        setCountry({});
      } else {
        toast.error(`Could not fetch transaction history, try again`);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  const historyObject = {
    fromDate: moment(from).format() || moment().format(),
    toDate: moment(to).endOf("day").format() || moment().format(),
    fromAmount: parseInt(minAmount) || 0,
    toAmount: parseInt(maxAmount) || 0,
    deliveryMethod: delivery?.value,
    countryTo: country?.iso3Code,
  };

  const tableData = historyData?.map((i, index) => {
    return { ...i, key: index };
  });

  return (
    <React.Fragment>
      <ConfirmTransactions
        show={show}
        handleClose={() => {
          setShow(false);
        }}
        paycenters={paycenters}
        data={selectedRow?.length > 0 ? selectedRow : historyData}
        dictionary={dictionary}
        routeType="manual"
      />
      <div className="app-content hor-content">
        <div className="container">
          <div className="page-header">
            <div>
              <h1 className="page-title">
                {dictionary
                  ? dictionary["WO_MANUAL_TRANSACTIONS_-447377986"]
                  : "Manual Transactions Routing"}
              </h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item active" aria-current="page">
                  {dictionary
                    ? dictionary["WO_PLEASE_ROUTE_YOUR_TR_1886911344"]
                    : `Please route your transactions manually to different paycenters here.`}
                </li>
              </ol>
            </div>
          </div>

          <div className="row row-sm">
            <div className="col-lg-12 col-md-12">
              <div className="card overflow-hidden">
                <div className="card-body">
                  <div className="form-row">
                    <div className="col-lg-6 col-md-6 mb-3">
                      <label>
                        {dictionary
                          ? dictionary["l_receiving_country"]
                          : `
                    Receiving Country`}
                      </label>
                      <Select
                        options={countries}
                        isClearable={false}
                        maxMenuHeight={250}
                        menuPlacement="bottom"
                        menuPortalTarget={menuPortalTarget}
                        value={country}
                        name="pcnFor"
                        onChange={(option) => {
                          setCountry(option);
                        }}
                        className="is-invalid"
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 mb-3">
                      <label>
                        {dictionary
                          ? dictionary["para_delivery_method"]
                          : `
                    Delivery Method`}
                      </label>
                      <Select
                        options={deliveryMethod()}
                        isClearable={false}
                        maxMenuHeight={250}
                        menuPlacement="bottom"
                        menuPortalTarget={menuPortalTarget}
                        value={delivery}
                        name="pcnFor"
                        onChange={(option) => {
                          seDeliveryMethod(option);
                        }}
                        className="is-invalid"
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 mb-3">
                      <label>
                        {dictionary
                          ? dictionary["WO_AMOUNT_FRO_1243490620"]
                          : `
                    Minimum Amount`}
                      </label>
                      <input
                        type={"text"}
                        className="form-control"
                        value={minAmount}
                        onChange={(e) => setMinAmount(e.target.value)}
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 mb-3">
                      <label>
                        {dictionary
                          ? dictionary["WO_MAXIMUM_AMOUN_-1198115106"]
                          : `
                    Maximum Amount`}
                      </label>
                      <input
                        type={"text"}
                        className="form-control"
                        value={maxAmount}
                        onChange={(e) => setMaxAMount(e.target.value)}
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 mb-3">
                      <label>
                        {dictionary
                          ? dictionary["WO_FUNDING_IN_CURRENCY_767682070"]
                          : `
                    Receiving Currency`}
                      </label>
                      <Select
                        options={currencies}
                        isClearable={false}
                        maxMenuHeight={250}
                        menuPlacement="bottom"
                        menuPortalTarget={menuPortalTarget}
                        value={currency}
                        name="pcnFor"
                        onChange={(option) => {
                          setCurrency(option);
                        }}
                        className="is-invalid"
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                      <label>
                        {dictionary ? dictionary["l_date_from"] : "Date From"}
                      </label>
                      <CustomDatePicker
                        getDate={setFrom}
                        showYearDropdown
                        selectDropdownMode
                        withPortal={true}
                        setMaxDate={new Date()}
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                      <label>
                        {dictionary ? dictionary["para_to_date"] : "To Date"}
                      </label>
                      <CustomDatePicker
                        getDate={setTo}
                        showYearDropdown
                        selectDropdownMode
                        withPortal={true}
                        setMaxDate={new Date()}
                      />
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <button
                        className="btn btn-primary margin-label w-100 d-flex flex-row justify-content-center align-items-center"
                        type="button"
                        onClick={() =>
                          dispatchTransactionHistory(historyObject)
                        }
                      >
                        {dictionary ? dictionary["l_search"] : "Search"}
                        {loading && (
                          <>
                            &nbsp;
                            <i className="fa fa-spinner fa-spin" />
                          </>
                        )}
                      </button>
                    </div>
                  </div>

                  {historyData?.length > 0 && (
                    <div className="form-row">
                      <div className="col-lg-6 col-md-6">
                        <button
                          className="btn btn-primary margin-label w-100 d-flex flex-row justify-content-center align-items-center"
                          type="button"
                          onClick={() => {
                            setShow(true);
                          }}
                        >
                          {dictionary
                            ? dictionary["WO_ROUTE_MANUALLY_SELEC_-1863030943"]
                            : "Route Manually Selected"}
                          {loading && (
                            <>
                              &nbsp;
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          )}
                        </button>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <button
                          className="btn btn-primary margin-label w-100 d-flex flex-row justify-content-center align-items-center"
                          type="button"
                          onClick={() => {
                            setShow(true);
                          }}
                        >
                          {dictionary
                            ? dictionary["WO_ROUTE_MANUALLY_AL_748678401"]
                            : "Route Manually All"}
                          {loading && (
                            <>
                              &nbsp;
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-lg-12 col-md-12">
              <div className="table-responsive">
                <Table
                  dataSource={tableData}
                  className="w-100 table tbody"
                  loading={loading}
                  rowSelection={rowSelection}
                >
                  <Column
                    title="Created Date"
                    dataIndex="createdDate"
                    key="1"
                    className=""
                    render={(text) => {
                      return (
                        <span className="text-lowercase whitespace">
                          {moment(text).format("DD-MM-YYYY")}
                        </span>
                      );
                    }}
                  />
                  <Column
                    title="Delivery method"
                    dataIndex="deliveryMethod"
                    key="2"
                    className=""
                  />
                  <Column title="PCN" dataIndex="pcn" key="3" className="" />
                  <Column
                    title="Currently Routed To"
                    dataIndex="pcn"
                    key="4"
                    className=""
                  />
                  <Column
                    title="Customer"
                    dataIndex="receiver"
                    key="5"
                    className=""
                    render={(text) => {
                      return (
                        <span className="text-lowercase whitespace">
                          {text}
                        </span>
                      );
                    }}
                  />
                  <Column
                    title="Sending Amount"
                    dataIndex="totalAmountPaid"
                    key="6"
                    className=""
                  />
                  <Column
                    title="Receiving country"
                    dataIndex="countryToName"
                    key="7"
                    className=""
                    render={(text) => {
                      return (
                        <span className="text-lowercase whitespace">
                          {text}
                        </span>
                      );
                    }}
                  />
                  <Column
                    title="Payment status"
                    dataIndex="status"
                    key="8"
                    className=""
                  />
                  <Column
                    title="Transacton status"
                    dataIndex="display_status"
                    key="9"
                    className=""
                  />
                  <Column
                    title="Action"
                    dataIndex="action"
                    key="10"
                    className=""
                    render={(text, record) => {
                      return (
                        <>
                          <Space size="middle">
                            <Tooltip
                              title={"View Transaction details"}
                              color="#212529"
                              placement="bottom"
                              arrowPointAtCenter={true}
                            >
                              <AiOutlineEye
                                className="cursor-pointer"
                                color={"#6259CA"}
                                fontSize={23}
                                onClick={() =>
                                  history.push({
                                    pathname: "/transfer/details",
                                    state: { data: { ...record } },
                                  })
                                }
                              />
                            </Tooltip>
                          </Space>
                        </>
                      );
                    }}
                  />
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Body;
